export const charities = [
  {
    title: "All Dogs Matter",
    logo: "alldogsmatter.png",
    logoLight: "alldogsmatter-light.png",
    linkTag: "AllDogsMatter"
  },
  {
    title: "Beyond Conflict",
    logo: "beyondconflict.png",
    logoLight: "beyondconflict-light.png",
    linkTag: "BeyondConflict"
  },
  {
    title: "Brain Tumour Research",
    logo: "btr.png",
    logoLight: "btr-light.png",
    linkTag: "BrainTumourResearch"
  },
  {
    title: "Cat Watch Rescue Shelter",
    logo: "cwrs.png",
    logoLight: "cwrs.png",
    linkTag: "CatWatchRescueShelter"
  },
  {
    title: "CFENC",
    logo: "cfenc.png",
    logoLight: "cfenc-light.png",
    linkTag: "CFENC"
  },
  {
    title: "Challenging MND",
    logo: "challengingmnd.png",
    logoLight: "challengingmnd-light.png",
    linkTag: "ChallengingMND"
  },
  {
    title: "Dogs for Autism",
    logo: "dogsforautism.png",
    logoLight: "dogsforautism.png",
    linkTag: "DogsForAutism"
  },
  {
    title: "Dragonfly Cancer Trust",
    logo: "dragonflycancertrust.png",
    logoLight: "dragonflycancertrust.png",
    linkTag: "DragonflyCancerTrust"
  },
  {
    title: "Head Up",
    logo: "headup.png",
    logoLight: "headup.png",
    linkTag: "HeadUp"
  },
  {
    title: "Helpful Hounds",
    logo: "helpfulhounds.png",
    logoLight: "helpfulhounds.png",
    linkTag: "HelpfulHounds"
  },
  {
    title: "IPS",
    logo: "ips.png",
    logoLight: "ips.png",
    linkTag: "IPS"
  },
  {
    title: "It Gets Better",
    logo: "itgetsbetter.png",
    logoLight: "itgetsbetter.png",
    linkTag: "ItGetsBetter"
  },
  {
    title: "Felix Fund",
    logo: "felixfund.png",
    logoLight: "felixfund-light.png",
    linkTag: "FelixFund"
  },
  {
    title: "The Foundation for Science and Technology",
    logo: "foundation-for-science-and-technology.png",
    logoLight: "foundation-for-science-and-technology-light.png",
    linkTag: "TheFoundationForScienceAndTechnology"
  },
  {
    title: "Leukaemia UK",
    logo: "leukaemiaUK.png",
    logoLight: "leukaemiaUK-light.png",
    linkTag: "LeukaemiaUK"
  },
  {
    title: "Mental Health Innovations",
    logo: "shout.png",
    logoLight: "shout-light.png",
    linkTag: "MentalHealthInnovations"
  },
  {
    title: "Millimetres 2 Mountains",
    logo: "millimetres2mountains.png",
    logoLight: "millimetres2mountains-light.png",
    linkTag: "Millimetres2Mountains"
  },
  {
    title: "Miracle`s Mission",
    logo: "miraclesmission.png",
    logoLight: "miraclesmission-light.png",
    linkTag: "MiraclesMission"
  },
  {
    title: "Momentum",
    logo: "momentum.png",
    logoLight: "momentum-light.png",
    linkTag: "Momentum"
  },
  {
    title: "Moodswings",
    logo: "moodswings.png",
    logoLight: "moodswings-light.png",
    linkTag: "Moodswings"
  },
  {
    title: "Nomad Opening Doors",
    logo: "nomad.png",
    logoLight: "nomad-light.png",
    linkTag: "NomadOpeningDoors"
  },
  {
    title: "Penny`s Ark",
    logo: "pennysark.png",
    logoLight: "pennysark.png",
    linkTag: "PennysArk"
  },
  {
    title: "Phoenix Rehoming",
    logo: "phoenixrehoming.png",
    logoLight: "phoenixrehoming-light.png",
    linkTag: "PhoenixRehoming"
  },
  {
    title: "Pipal Tree",
    logo: "pipaltree.png",
    logoLight: "pipaltree.png",
    linkTag: "PipalTree"
  },
  {
    title: "Rain Rescue",
    logo: "rainrescue.png",
    logoLight: "rainrescue.png",
    linkTag: "RainRescue"
  },
  {
    title: "Sense",
    logo: "sense.png",
    logoLight: "sense-light.png",
    linkTag: "SENSE"
  },
  {
    title: "Support Dogs",
    logo: "support-dogs.png",
    logoLight: "support-dogs-light.png",
    linkTag: "SupportDogs"
  },
  {
    title: "The Scar Free Foundation",
    logo: "scarfreefoundation.png",
    logoLight: "scarfreefoundation.png",
    linkTag: "TheScarFreeFoundation"
  },
  {
    title: "War Paws",
    logo: "warpaws.png",
    logoLight: "warpaws.png",
    linkTag: "WarPaws"
  },
  {
    title: "When You Wish Upon a Star",
    logo: "whenyouwishuponastar.png",
    logoLight: "whenyouwishuponastar.png",
    linkTag: "whenyouwishuponastar"
  },
]